import React from "react";
import { func, bool, string } from "prop-types";

import "./confirmationModal.css";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CustomCloseModalButton from "../../common/CustomCloseModalButton";

const ConfirmationModal = ({
  isOpen,
  confirmModal,
  modalHeader,
  children,
  closeModal,
  size,
  className = "",
}) => (
  <Modal className={className} isOpen={isOpen} size={size}>
    {modalHeader && (
      <ModalHeader close={<CustomCloseModalButton toggle={closeModal} />}>
        {modalHeader}
      </ModalHeader>
    )}
    {children && <ModalBody className="modal-body">{children}</ModalBody>}
    <ModalFooter>
      <Button
        className="client-details-modal-button confirm-button"
        onClick={confirmModal}
      >
        Yes
      </Button>
      <Button
        className="client-details-modal-button cancel-button"
        onClick={closeModal}
      >
        No
      </Button>
    </ModalFooter>
  </Modal>
);

ConfirmationModal.propTypes = {
  isOpen: bool.isRequired,
  confirmModal: func.isRequired,
  modalHeader: string.isRequired,
  closeModal: func.isRequired,
  className: string,
};

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/modals/confirmation-modal/ConfirmationModal.jsx